import React, { useEffect, useState } from "react";
import {
  Col,
  FormControl,
  Grid,
  Row,
  Button,
  Pagination,
} from "react-bootstrap";
import moment from "moment";
import NotificationSystem from "react-notification-system";
import Datetime from "react-datetime";
import ClaimReconciliationTable from "./claimReconciliationTable";
import Select from "react-select";
import {
  getAllClaimReconciliationList,
  deleteReports,
  updateStatusChange,
} from "api/claimReconcilation/ClaimReconcilation";
import Card from "components/Card/Card";
import Swal from "sweetalert2";
import DateRangePicker from "react-daterange-picker";

const ClaimReconciliation = () => {
  const token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const _notificationSystem = React.createRef();

  const [noRecordFound, setNoRecordFound] = useState(false);
  const [loading, setLoading] = useState(false);
  const [claimReconciliationData, setClaimReconciliationData] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [selectedClaimId, setSelectedClaimId] = useState([]);
  const [claimStatusChange, setClaimStatusChange] = useState(null);
  const [statusFilter, setStatusFilter] = useState("");
  const [isDateRangePickerOpen, setIsDateRangePickerOpen] = useState(false);
  const [selecttedRange, setSelecttedRange] = useState("");

  useEffect(() => {
    claimReconciliationDates(
      obj,
      currentPage,
      search,
      statusFilter,
      selecttedRange,
    );
  }, [search, currentPage, statusFilter, selecttedRange]);

  const claimReconciliationDates = async () => {
    setLoading(true);

    try {
      let startDate = "";
      let endDate = "";

      if (selecttedRange) {
        startDate = selecttedRange.start
          ? moment(selecttedRange.start).format("YYYY-MM-DD")
          : "";
        endDate = selecttedRange.end
          ? moment(selecttedRange.end).format("YYYY-MM-DD")
          : "";
      }

      const res = await getAllClaimReconciliationList(
        obj,
        currentPage,
        search,
        statusFilter,
        startDate,
        endDate,
      );

      if (res.data && res.data.length > 0) {
        const filteredData = res.data.filter(
          (item) => item.type !== "utilization excel",
        );
        if (filteredData.length > 0) {
          setClaimReconciliationData(filteredData);
          setCurrentPage(res.current_page);
          setTotalPage(res.last_page);
          setNoRecordFound(false);
        } else {
          setNoRecordFound(true);
        }
      } else {
        setNoRecordFound(true);
      }
    } catch (error) {
      console.error("Error fetching claim reconciliation data:", error);
      setNoRecordFound(true);
    } finally {
      setLoading(false);
    }
  };

  let items = [];
  for (let number = 1; number <= totalPage; number++) {
    items.push(
      <Pagination.Item
        key={number}
        onClick={() => setCurrentPage(number)}
        active={number === currentPage}
      >
        {number}
      </Pagination.Item>,
    );
  }

  const showNotification = async (type, id) => {
    let config = {
      width: "500px",
      focusConfirm: false,
      confirmButtonText:
        type === "delete" || type === "updateStatus"
          ? "<font size='4px'>Yes</font>"
          : "<font size='4px'>OK</font>",
      cancelButtonText:
        type === "delete" || type === "updateStatus"
          ? "<font size='4px'>No</font>"
          : "<font size='4px'>OK</font>",
      title: '<span style="font-size:38px;">Are You Sure?</span>',
      icon: "warning",
      showCancelButton: true,
      showConfirmButton:
        type === "delete" || type === "updateStatus" ? true : false,
      showCloseButton: true,
    };

    switch (type) {
      case "delete":
        config = {
          ...config,
          html: '<span style="font-size:26px;">You want to delete this Report</span>',
        };
        break;

      case "updateStatus":
        config = {
          ...config,
          html: '<span style="font-size:26px;">Update claim reconciliation status?</span>',
        };
        break;

      case "noReportSelected":
      case "noStatusSelected":
        const titles = {
          noReportSelected: "Please Select a Report",
          noStatusSelected: "Please Select The Status",
        };
        config = {
          ...config,
          title: `<span style="font-size:38px;">${titles[type]}</span>`,
          html: '<span style="font-size:26px;">To Update</span>',
        };
        break;

      default:
        config = {
          ...config,
          title: "Notification",
          html: "No message provided",
        };
    }

    const result = await Swal.fire(config).then((result) => {
      if (result.isConfirmed && type === "delete") {
        deleteOrder(id);
      } else if (result.isConfirmed && type === "updateStatus") {
        updateStatuses();
      }
    });
    return result;
  };

  const handleDeleteOrder = (id) => {
    showNotification("delete", id);
  };
  const onToggle = () => {
    setIsDateRangePickerOpen(!isDateRangePickerOpen);
    setCurrentPage(1);
  };

  const deleteOrder = async (id) => {
    const notification = _notificationSystem.current;
    await deleteReports(id, obj).then((res) => {
      if (res.data.success == true) {
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>{res.data.message}</b>
            </div>
          ),
          level: "success",
          position: "bl",
          autoDismiss: 15,
        });

        setLoading(true);
        claimReconciliationDates();
      } else {
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>{res.data.message}</b>
            </div>
          ),
          level: "error",
          position: "bl",
          autoDismiss: 15,
        });
      }
    });
  };

  const handleChangeStatus = async () => {
    if (!selectedClaimId || selectedClaimId.length === 0) {
      await showNotification("noReportSelected", "");
      return;
    }
    const selectedClaims = claimReconciliationData.filter((claim) =>
      selectedClaimId.includes(claim.id),
    );
    const uniqueStatuses = [...new Set(selectedClaims.map((c) => c.status))];
    if (uniqueStatuses.length > 1) {
      await Swal.fire({
        width: "500px",
        icon: "warning",
        title:
          "<div style='font-size:37px; font-weight:bold;'>Different Statuses Selected</div>",
        html: "<span style='font-size:23px'>Please select claims with the same status.</span>",
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        showCloseButton: true,
      });
      return;
    }
    if (!claimStatusChange) {
      await showNotification("noStatusSelected", "");
      return;
    }
    const confirmed = showNotification("updateStatus", "");
  };
  const updateStatuses = async () => {
    const notification = _notificationSystem.current;
    try {
      const res = await updateStatusChange(
        obj,
        claimStatusChange.label,
        selectedClaimId,
      );
      if (res.data.success) {
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>{res.data.message}</b>
            </div>
          ),
          level: "success",
          position: "bl",
          autoDismiss: 15,
        });

        setLoading(true);
        setSelectedClaimId([]);
        claimReconciliationDates();
        setClaimStatusChange(null);
      } else {
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>{res.data.message}</b>
            </div>
          ),
          level: "error",
          position: "bl",
          autoDismiss: 15,
        });
      }
    } catch (error) {
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>Error updating status.</b>
          </div>
        ),
        level: "error",
        position: "bl",
        autoDismiss: 15,
      });
    }
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearch(value);
  };

  const ResetValues = () => {
    setClaimStatusChange(null);
    setSearch("");
    setStatusFilter("");
    setSelectedClaimId([]);
    claimReconciliationDates();
    setIsDateRangePickerOpen(false);
    setSelecttedRange("");
    setCurrentPage(1);
  };

  const handleFilterByStatus = (selectedStatus) => {
    setStatusFilter(selectedStatus ? selectedStatus.value : "");
  };

  const getStatusOptions = () => {
    if (!selectedClaimId || selectedClaimId.length === 0) return [];
    const selectedClaims = claimReconciliationData.filter((claim) =>
      selectedClaimId.includes(claim.id),
    );
    const allStatuses = [...new Set(selectedClaims.map((c) => c.status))];
    if (allStatuses.length > 1) return [];
    const status = allStatuses[0];
    switch (status) {
      case "Generated":
        return [
          { value: "Payment Request Sent", label: "Payment Request Sent" },
        ];
      case "Payment Request Sent":
        return [{ value: "Payment Received", label: "Payment Received" }];
      case "Payment Received":
        return [{ value: "Completed", label: "Completed" }];
      case "Completed":
        return [];
      default:
        return [];
    }
  };

  return (
    <div className="main-content">
      <Grid fluid>
        <NotificationSystem ref={_notificationSystem} />
        <Card
          tableFullWidth
          content={
            <>
              <form>
                <div className="table-responsive">
                  <>
                    <Row style={{ padding: "5px" }}>
                      <Col xs={3} sm={3} md={3} lg={3}>
                        <Select
                          value={claimStatusChange}
                          placeholder="Status Change"
                          options={getStatusOptions()}
                          onChange={(selectedOption) =>
                            setClaimStatusChange(selectedOption)
                          }
                        />{" "}
                        &nbsp;&nbsp;
                      </Col>{" "}
                      <Button
                        className="fl_mb_web_1 btn-fill fl_mb_1"
                        style={{ marginTop: "1px" }}
                        onClick={handleChangeStatus}
                      >
                        Change Status
                      </Button>
                    </Row>
                    <Row
                      className="OrderList_fill"
                      style={{
                        borderRadius: "5px",
                        paddingTop: "11px",
                        paddingBottom: "10px",
                        width: "98%",
                        marginLeft: "7px",
                      }}
                    >
                      <Col xs={2} sm={2} md={2} lg={2}>
                        <Select
                          name="statusFilter"
                          value={
                            statusFilter
                              ? { value: statusFilter, label: statusFilter }
                              : null
                          }
                          placeholder="Search Status"
                          onChange={handleFilterByStatus}
                          options={[
                            {
                              value: "Payment Request Sent",
                              label: "Payment Request Sent",
                            },
                            {
                              value: "Payment Received",
                              label: "Payment Received",
                            },
                            { value: "Completed", label: "Completed" },
                            { value: "Generated", label: "Generated" },
                          ]}
                        />
                      </Col>
                      <Col xs={3} sm={3} md={3} lg={3}>
                        <FormControl
                          style={{ marginTop: "1px" }}
                          name="search"
                          placeholder="Search Organization Name or Inv.no."
                          type="text"
                          className="text-input"
                          value={search}
                          onChange={(event) => handleSearchChange(event)}
                        />
                      </Col>

                      <Col
                        xs={4}
                        sm={4}
                        md={4}
                        lg={4}
                        style={{ display: "flex" }}
                      >
                        <div style={{ position: "relative" }}>
                          <Button
                            value="Toggle date picker"
                            className="fl_mb_web_1 btn-fill fl_mb_1 w_150"
                            style={{
                              backgroundColor: "white",
                              color: "black",
                              marginTop: "3px",
                            }}
                            onClick={() => onToggle()}
                          >
                            Date Range
                          </Button>
                          {isDateRangePickerOpen && (
                            <div
                              style={{
                                position: "absolute",
                                top: "45px",
                                zIndex: 9999,
                              }}
                            >
                              <DateRangePicker
                                value={selecttedRange}
                                onSelect={(date) => setSelecttedRange(date)}
                              />
                            </div>
                          )}
                        </div>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <Button
                          className="fl_mb_web_1 btn-fill fl_mb_1"
                          style={{ marginTop: "1px" }}
                          onClick={ResetValues}
                        >
                          Reset
                        </Button>
                      </Col>
                    </Row>
                  </>
                  <Col>
                    <Card
                      content={
                        <Row>
                          <ClaimReconciliationTable
                            loading={loading}
                            noRecordFound={noRecordFound}
                            data={claimReconciliationData}
                            handleDeleteOrder={handleDeleteOrder}
                            selectedClaimId={selectedClaimId}
                            setSelectedClaimId={setSelectedClaimId}
                          />
                        </Row>
                      }
                    />
                  </Col>
                </div>
              </form>
              <div style={{ textAlign: "center" }}>
                <Pagination bsSize="medium">{items}</Pagination>
              </div>
            </>
          }
        />
      </Grid>
    </div>
  );
};

export default ClaimReconciliation;
